import React from 'react'

const LockGreenSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 17.826 18.495'
    >
      <path
        id='lock-password-svgrepo-com'
        d='M4.9,9.1V7.266a6.016,6.016,0,1,1,12.033,0V9.1a3.109,3.109,0,0,1,2.114.735c.783.783.783,2.044.783,4.565s0,3.781-.783,4.565-2.044.783-4.565.783H7.348c-2.521,0-3.782,0-4.565-.783S2,16.918,2,14.4s0-3.781.783-4.565A3.109,3.109,0,0,1,4.9,9.1ZM6.234,7.266a4.679,4.679,0,1,1,9.359,0V9.052c-.341,0-.712,0-1.114,0H7.348c-.4,0-.773,0-1.114,0Zm1.114,8.022a.891.891,0,1,0-.891-.891A.891.891,0,0,0,7.348,15.288Zm3.565,0a.891.891,0,1,0-.891-.891A.891.891,0,0,0,10.913,15.288ZM15.37,14.4a.891.891,0,1,1-.891-.891A.891.891,0,0,1,15.37,14.4Z'
        transform='translate(-2 -1.25)'
        fill='#b5ccc2'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default LockGreenSvg
